import { gql } from 'apollo-angular'

export default gql`
  mutation delete_comment_category_by_pk($id: Int!) {
    delete_comment_category(where: { id: { _eq: $id } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`
